let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4TIxA")).then(() => parcelRequire('fWk0Z'));